import { render, staticRenderFns } from "./TwitterRss.vue?vue&type=template&id=52d3f4d6"
import script from "./TwitterRss.vue?vue&type=script&lang=js"
export * from "./TwitterRss.vue?vue&type=script&lang=js"
import style0 from "./TwitterRss.vue?vue&type=style&index=0&id=52d3f4d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports